module.exports = __webpack_public_path__ + "static/media/balloon-v3.1ff0f9af.svg";